import { StarRating } from './StarRating';
import type { Review } from '@shared/types/product.types';

interface ReviewListProps {
  reviews: Review[];
}

export function ReviewList({ reviews }: ReviewListProps) {
  if (reviews.length === 0) {
    return <p className="text-gray-500">No reviews yet. Be the first to review!</p>;
  }

  const avgRating = reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length;

  return (
    <div>
      <div className="mb-6 flex items-center gap-3">
        <StarRating rating={avgRating} />
        <span className="text-sm text-gray-400">
          {avgRating.toFixed(1)} ({reviews.length} review{reviews.length !== 1 ? 's' : ''})
        </span>
      </div>
      <div className="space-y-4">
        {reviews.map((review) => (
          <div key={review.id} className="rounded-lg border border-white/10 bg-navy-900/30 p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                {review.user?.avatarUrl && (
                  <img src={review.user.avatarUrl} alt="" className="h-6 w-6 rounded-full" />
                )}
                <span className="text-sm font-medium text-white">{review.user?.name || 'Anonymous'}</span>
              </div>
              <StarRating rating={review.rating} size="sm" />
            </div>
            <h4 className="mt-2 font-medium text-white">{review.title}</h4>
            {review.body && <p className="mt-1 text-sm text-gray-400">{review.body}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
